const firebaseConfig = {
    apiKey: "AIzaSyBzTd0phzuUKk2vSvJSlolo2oYMRS3-Rr0",
    authDomain: "creative-agency-project2020.firebaseapp.com",
    databaseURL: "https://creative-agency-project2020.firebaseio.com",
    projectId: "creative-agency-project2020",
    storageBucket: "creative-agency-project2020.appspot.com",
    messagingSenderId: "983605987885",
    appId: "1:983605987885:web:007c4a41cf4906094e86a4"
};

export default firebaseConfig;